/**
 * Task Import Routes
 * Routes for the Task Imports management page
 */
import permissions from '@Share/config/permissions';

export default [
  {
    path: '/manage-task-imports',
    name: 'TaskImportsAdmin',
    component: () => import('./views/TaskImports.vue'),
    meta: {
      requiresAuth: true,
      layout: 'accountLayout',
      title: 'Task Imports Management',
      permissions: [permissions.TaskImport.View],
    },
  },
];
